import { render } from "./newProgram.vue?vue&type=template&id=7162c05d&scoped=true"
import script from "./newProgram.vue?vue&type=script&lang=js"
export * from "./newProgram.vue?vue&type=script&lang=js"

import "./newProgram.vue?vue&type=style&index=0&id=7162c05d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7162c05d"]])

export default __exports__